package ru.dinarastepina.fabvocab.web.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import ru.dinarastepina.fabvocab.web.theme.Slate800

@Composable
fun TopBar(
    title: String,
    modifier: Modifier = Modifier,
    navigation: @Composable (() -> Unit)? = null,
    actions: @Composable (() -> Unit)? = null,
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(topBottom = 16.px, leftRight = 20.px),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            navigation?.invoke()
            SpanText(
                title,
                modifier = Modifier
                    .fontSize(22.px)
                    .fontWeight(FontWeight.Black)
                    .color(Slate800)
                    .letterSpacing((-0.5).px),
            )
        }
        actions?.invoke()
    }
}
